/**
 * "Co nowego" — wersjonowany modal ze sliderem nowości na stronie głównej.
 * Wersja treści pochodzi z PHP (WhatsNewHelper::VERSION, atrybut
 * data-whats-new-version); po zamknięciu trafia do localStorage i modal nie
 * otwiera się automatycznie do czasu podbicia wersji. Triggery ręczne:
 * [data-whats-new-open], wskaźniki nieobejrzanej wersji: [data-whats-new-indicator].
 */

var WHATS_NEW_STORAGE_KEY = 'rcn-whats-new-version';
var AUTO_OPEN_DELAY_MS = 900;
var BLOCKING_URL_PARAMS = [
    'open_transakcja',
    'open_signal',
    'open_gunb',
    'open_bdot',
    'draft_listing_id',
    'edit_listing_id',
    'signal_notice',
];

var initialized = false;
var rootEl = null;
var trackEl = null;
var slideEls = null;
var dotEls = null;
var prevBtn = null;
var nextBtn = null;
var version = '';
var currentIndex = 0;
var lastFocusedEl = null;
var scrollRaf = null;

function storedVersion() {
    try {
        return window.localStorage.getItem(WHATS_NEW_STORAGE_KEY);
    } catch (e) {
        return null;
    }
}

function markSeen() {
    try {
        window.localStorage.setItem(WHATS_NEW_STORAGE_KEY, version);
    } catch (e) { /* noop */ }
    updateIndicators();
}

function hasUnseen() {
    try {
        return window.localStorage.getItem(WHATS_NEW_STORAGE_KEY) !== version;
    } catch (e) {
        return false;
    }
}

function updateIndicators() {
    var unseen = hasUnseen();
    document.querySelectorAll('[data-whats-new-indicator]').forEach(function(el) {
        el.classList.toggle('is-visible', unseen);
    });
}

function isOpen() {
    return !!rootEl && !rootEl.hidden;
}

function updateUi() {
    if (dotEls) {
        dotEls.forEach(function(dot, i) {
            var active = i === currentIndex;
            dot.classList.toggle('is-active', active);
            dot.setAttribute('aria-selected', active ? 'true' : 'false');
            dot.setAttribute('tabindex', active ? '0' : '-1');
        });
    }
    var lastIndex = slideEls ? slideEls.length - 1 : 0;
    if (prevBtn) prevBtn.disabled = currentIndex <= 0;
    if (nextBtn) nextBtn.disabled = currentIndex >= lastIndex;
}

function goTo(index, behavior) {
    if (!trackEl || !slideEls || !slideEls.length) return;
    var clamped = Math.max(0, Math.min(index, slideEls.length - 1));
    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var scrollBehavior = behavior === 'auto' || reducedMotion ? 'instant' : (behavior || 'smooth');
    // Auto-open always starts on slide 0. Avoid reading clientWidth immediately
    // after rootEl.hidden=false, which would synchronously force layout.
    if (clamped === 0) {
        trackEl.scrollTo({ left: 0, behavior: scrollBehavior });
    } else {
        trackEl.scrollTo({ left: clamped * trackEl.clientWidth, behavior: scrollBehavior });
    }
    currentIndex = clamped;
    updateUi();
}

function onTrackScroll() {
    if (scrollRaf) return;
    scrollRaf = window.requestAnimationFrame(function() {
        scrollRaf = null;
        if (!trackEl || !trackEl.clientWidth) return;
        var index = Math.round(trackEl.scrollLeft / trackEl.clientWidth);
        if (index !== currentIndex) {
            currentIndex = index;
            updateUi();
        }
    });
}

function open() {
    if (!rootEl || isOpen()) return;
    lastFocusedEl = document.activeElement;
    rootEl.hidden = false;
    goTo(0, 'auto');
    var closeBtn = rootEl.querySelector('.nm-whats-new__close');
    if (closeBtn) closeBtn.focus();
}

function close() {
    if (!rootEl || !isOpen()) return;
    rootEl.hidden = true;
    markSeen();
    if (lastFocusedEl && typeof lastFocusedEl.focus === 'function') {
        try { lastFocusedEl.focus(); } catch (e) { /* noop */ }
    }
    lastFocusedEl = null;
}

function trapFocus(event) {
    var dialog = rootEl.querySelector('.nm-whats-new__dialog');
    if (!dialog) return;
    var focusables = dialog.querySelectorAll(
        'button:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])'
    );
    if (!focusables.length) return;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
    }
}

function onKeydown(event) {
    if (!isOpen()) return;
    if (event.key === 'Escape') {
        event.preventDefault();
        close();
    } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        goTo(currentIndex + 1);
    } else if (event.key === 'ArrowLeft') {
        event.preventDefault();
        goTo(currentIndex - 1);
    } else if (event.key === 'Tab') {
        trapFocus(event);
    }
}

function onCtaClick(event, cta) {
    markSeen();
    var action = cta.getAttribute('data-whats-new-action');
    if (!action) return; // zwykła nawigacja — wersja już zapisana
    event.preventDefault();
    close();
    if (action === 'add-signal') {
        var fabAction = document.querySelector('.nm-fab__action[data-fab-action="add-signal"]');
        if (fabAction) fabAction.click();
    } else if (action === 'open-parcel-filters') {
        var parcelAsset = document.querySelector('.nm-asset-btn[data-asset="dzialki"]');
        var filtersTab = document.querySelector('.nm-tab[data-tab="filters"]');
        var parcelScope = document.querySelector('.nm-filter-subtab[data-filter-scope="parcels"]');
        if (parcelAsset && !parcelAsset.classList.contains('is-active')) parcelAsset.click();
        if (filtersTab) filtersTab.click();
        if (parcelScope) parcelScope.click();
        window.setTimeout(function() {
            var neighbourBox = document.querySelector('.nm-egib-neighbour-box');
            var panelScroll = neighbourBox && neighbourBox.closest('.nm-panel-scroll');
            if (neighbourBox && panelScroll) {
                panelScroll.scrollTo({
                    top: Math.max(0, neighbourBox.offsetTop - 180),
                    behavior: window.matchMedia
                        && window.matchMedia('(prefers-reduced-motion: reduce)').matches
                        ? 'auto'
                        : 'smooth',
                });
            }
        }, 40);
    }
}

function onRootClick(event) {
    var closeTrigger = event.target.closest('[data-whats-new-close]');
    if (closeTrigger) {
        close();
        return;
    }
    var dot = event.target.closest('[data-whats-new-dot]');
    if (dot) {
        var targetIndex = parseInt(dot.getAttribute('data-whats-new-dot'), 10) || 0;
        goTo(targetIndex, Math.abs(targetIndex - currentIndex) > 1 ? 'auto' : 'smooth');
        return;
    }
    if (event.target.closest('[data-whats-new-prev]')) {
        goTo(currentIndex - 1);
        return;
    }
    if (event.target.closest('[data-whats-new-next]')) {
        goTo(currentIndex + 1);
        return;
    }
    var cta = event.target.closest('[data-whats-new-cta]');
    if (cta) onCtaClick(event, cta);
}

function initMediaLoaders() {
    rootEl.querySelectorAll('.nm-whats-new__media img').forEach(function(img) {
        var media = img.closest('.nm-whats-new__media');
        if (!media) return;
        var markLoaded = function() {
            media.classList.add('is-loaded');
        };
        if (img.complete && img.naturalWidth > 0) {
            markLoaded();
        } else {
            img.addEventListener('load', markLoaded, { once: true });
            img.addEventListener('error', markLoaded, { once: true });
        }
    });
}

function autoOpenBlocked() {
    var params = new URLSearchParams(window.location.search);
    return BLOCKING_URL_PARAMS.some(function(name) {
        return params.has(name);
    });
}

/**
 * True when a visitor who has seen an earlier version of „Co nowego” has not
 * seen this one. The start dialog then lets the news open first.
 */
export function hasPendingNews() {
    var root = document.getElementById('nm-whats-new');
    if (!root) return false;
    var current = root.getAttribute('data-whats-new-version') || '';
    try {
        var stored = window.localStorage.getItem(WHATS_NEW_STORAGE_KEY);
        return stored !== null && stored !== current;
    } catch (e) {
        return false;
    }
}

/**
 * `options.suppressAutoOpen`: the start dialog opened instead (start-dialog.js).
 * A visitor who has never seen any version then counts as having seen the
 * current one: the news describe changes they did not know the old way of.
 */
export function initWhatsNew(options) {
    var suppressAutoOpen = Boolean(options && options.suppressAutoOpen);
    if (initialized) return;
    rootEl = document.getElementById('nm-whats-new');
    if (!rootEl) return;
    initialized = true;

    version = rootEl.getAttribute('data-whats-new-version') || '';
    trackEl = rootEl.querySelector('[data-whats-new-track]');
    slideEls = Array.prototype.slice.call(rootEl.querySelectorAll('[data-whats-new-slide]'));
    dotEls = Array.prototype.slice.call(rootEl.querySelectorAll('[data-whats-new-dot]'));
    prevBtn = rootEl.querySelector('[data-whats-new-prev]');
    nextBtn = rootEl.querySelector('[data-whats-new-next]');

    rootEl.addEventListener('click', onRootClick);
    if (trackEl) trackEl.addEventListener('scroll', onTrackScroll, { passive: true });
    document.addEventListener('keydown', onKeydown);
    window.addEventListener('resize', function() {
        if (isOpen()) goTo(currentIndex, 'auto');
    });

    document.addEventListener('click', function(event) {
        var trigger = event.target.closest('[data-whats-new-open]');
        if (trigger) open();
    });

    initMediaLoaders();
    updateIndicators();
    updateUi();

    if (suppressAutoOpen) {
        if (storedVersion() === null) markSeen();
    } else if (hasUnseen() && !autoOpenBlocked()) {
        window.setTimeout(open, AUTO_OPEN_DELAY_MS);
    }
}
